:host {
  .link {
    color: #5d6268ff;
    text-decoration: none;
    margin-bottom: 16px;

    &:hover {
      color: hsl(0deg 0% 100% / 75%);
    }

    &.active,
    &.active:hover {
      color: rgb(40 140 236);
    }
  }
}

:host([type='regular']) {
  display: flex;
  gap: 16px;
}

:host([type='circle']) {
  display: flex;
  gap: 16px;
  margin-top: auto;
  margin-bottom: 48px;

  .circle-link {
    display: inline-block;
    width: 2.7rem;
    height: 2.7rem;
    font-size: 0.85rem;
    line-height: 2.6rem;
    border: 1px solid #fff;
    color: #fff;
    border-radius: 999px;

    &:hover,
    &:active {
      color: hsl(0deg 0% 100% / 75%);
      text-decoration: none;
      border: 1px solid hsl(0deg 0% 100% / 75%);
    }

    &.active,
    &.active:hover,
    &.active:active {
      color: rgb(40 140 236);
      border: 1px solid rgb(40 140 236);
    }

    .inner-link {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }
}
